import React, { createPortal, useEffect, useState } from "preact/compat";
import constants from "../constants";
import store from "../store";
import * as actions from '../actions';
import util from "../util";
import Spinner from "./Spinner";
import Masonry from "react-masonry-component";
import { DeleteOutlined, EllipsisOutlined } from "@ant-design/icons";
import CropImageIcon from "./icon/CropImageIcon";
import ADAIcon from "./icon/ADAIcon";
import imageService from "../service/imageService";
import { addComponent, VIEWPORT_CENTER } from "../canvas/component";
import { goToView } from "../actions";
import favoriteAssetService from "../service/favoriteAssetService";
import FavoriteButton from "./FavoriteButton";
import UploadImageCard from "./card/UploadImageCard";
const { dispatch } = store;

export interface OrganizeUploadsModalProps {
  open: boolean;
  onClose: () => void;
  openAltTextModal: (image: any, event: any) => void;
  openCropper: (image: any, event: any) => void;
  setUploadedImages: (images: any[]) => void;
  uploadedImages: any[];
}

export default function OrganizeUploadsModal({ open, onClose, openAltTextModal, openCropper, setUploadedImages, uploadedImages }: OrganizeUploadsModalProps) {

  const imageLoadingSpinner = <Spinner />;
  const [selectedImages, setSelectedImages] = useState<any[]>([]);

  function organizeUploads() {
    onClose();
    if (store.getState().isMobileVersion) {
      store.dispatch(actions.setIsMobileAside(true));
    }
  }

  function handleMenuToggle(event: any) {
    event.stopPropagation();

    const menuToggle = event.currentTarget;
    const dropdownMenu = menuToggle.nextElementSibling;
    const componentRect = $(menuToggle).closest('.component-wrapper')[0]!.getBoundingClientRect();
    const containerRect = document.querySelector('.masonry-grid')?.getBoundingClientRect();

    // Check if there's enough space on the right
    const spaceOnRight = (containerRect?.right ?? 0) - (componentRect?.right ?? 0);
    // Assuming dropdown menu width is 150px, adjust this value as needed
    if (spaceOnRight < 150) {
      dropdownMenu.style.left = 'auto';
      dropdownMenu.style.right = '0';
    } else {
      dropdownMenu.style.left = '0';
      dropdownMenu.style.right = 'auto';
    }

    if (dropdownMenu.style.display !== 'block') {
      dropdownMenu.style.display = 'block';
    } else {
      dropdownMenu.style.display = 'none';
    }
    $(dropdownMenu).toggleClass('show');
  }

  function handleCheckboxChange(image: any) {
    const imageId = image.id;
    if (selectedImages.includes(imageId)) {
      setSelectedImages(selectedImages.filter(id => id !== imageId));
    } else {
      setSelectedImages([...selectedImages, imageId]);
    }

    // console.log(selectedImages);
  }

  function handleSelectAll() {
    if (selectedImages.length === uploadedImages.length) {
      setSelectedImages([]);
    } else {
      setSelectedImages(uploadedImages.map((image: any) => image.id));
    }
  }

  function removeImage(image: any, event: any) {
    event.stopPropagation();

    (window as any).ConfirmationModal.show({
      title: 'Are you sure?',
      body: 'This image will be removed from your gallery.',
      acceptLabel: 'Ok',
      declineLabel: 'Cancel',
      top: '35%',
      onAccept: () => {
        imageService.removeMemberImage(image.id).then(response => {
          setUploadedImages(uploadedImages.filter(it => it.id !== image.id))
        })
      },
      onDecline: () => {
        (window as any).ConfirmationModal.hide()
      }
    })
  }

  function removeSelectedImages(event: any) {
    event.stopPropagation();

    (window as any).ConfirmationModal.show({
      title: 'Are you sure?',
      body: 'The selected images will be removed from your gallery.',
      acceptLabel: 'Delete',
      declineLabel: 'Cancel',
      top: '35%',
      onAccept: () => {
        selectedImages.forEach((imageId: any) => {
          imageService.removeMemberImage(imageId).then(response => {
            // setTimeout(() => {
            //   setUploadedImages(uploadedImages.filter(it => it.id !== imageId))
            // }, 100)
          })

          setUploadedImages(uploadedImages.filter(it => !selectedImages.includes(it.id)))
        })


      },
      onDecline: () => {
        (window as any).ConfirmationModal.hide()
      }
    })
  }

  function addSelectedImagesToDesign() {
    const $page = util.getPageInViewport($('.page')) as any;

    selectedImages.forEach((imageId: any) => {
      const $target = $(`#upload-${imageId}`).clone();
      $target.find('.dropdown').remove();
      $target.find('.label').remove();
      $target.find('.checkbox').remove();

      if ($target.length) {
        addComponent($page!!.attr('id') ?? '', $target.html(), {
          position: {
            left: VIEWPORT_CENTER,
            top: VIEWPORT_CENTER
          },
          isFromTemplate: true,
        })
      }
    })

    onClose();

    if (store.getState().isMobileVersion) {
      store.dispatch(actions.setIsMobileAside(false));
    }
  }

  function addSelectedImagesToFavorites() {
    selectedImages.forEach((imageId: any) => {
      favoriteAssetService.createFavoriteAsset(store.getState().memberId, imageId, 'upload').then((response) => {
        // console.log(response);
      });

      uploadedImages.forEach(it => {
        if (it.id === imageId) {
          it.isFavorite = true;
        }
      });

      setUploadedImages(uploadedImages.map(img => ({ ...img })));
    });
  }

  function startCropper(image: any, event: any) {
    setTimeout(() => {
      onClose();
    }, 100);

    setTimeout(() => {
      openCropper(image, event)
    }, 100);
  }

  function startAltTextModal(image: any, event: any) {
    setTimeout(() => {
      onClose();
    }, 100);

    setTimeout(() => {
      openAltTextModal(image, event)
    }, 200);
  }

  const elements = uploadedImages.map(image => {
    // if ((props.isReplaceFrameMode && util.isVideoFrame(props.$element) && (!image.isMp4 && !image.isWebM)) ||
    //   (props.isReplaceFrameMode && !util.isVideoFrame(props.$element) && (image.isMp4 || image.isWebM))) {
    //   return;
    // }

    if (image.isMp4 || image.isWebM) {
      const component = <div className="component-wrapper" onClick={() => handleCheckboxChange(image)}>
        <div className="component template video-frame" data-component="video-frame">
          <div className="frame" data-component="video-frame" data-type="video-frame" style="display: table-row;" data-asset-id={image.assetId}>
            <div className="video" style={`width: 100%; height: 100%;`} data-original-bg-video={util.getUploadedImgSrc(image)} role="img" aria-label={image.altText}
              dangerouslySetInnerHTML={{
                __html:
                  `<video 
               loop muted disablepictureinpicture playsinline 
               src=${util.getUploadedImgSrc(image)}  
               style="width: 100%; height: 100%; object-fit: cover;" />`
              }} />

            <div className={`checkbox ${selectedImages.includes(image.id) ? "selected" : ""}`}>
              <input type="checkbox" id={`checkbox-${image.id}`} checked={selectedImages.includes(image.id)} />
            </div>

            <div className={`actions ${!image.isOld ? "remove" : "hidden"}`}>
              <div className="dropdown menu-container">
                <div
                  className="dropdown-toggle menu-toggle"
                  onClick={handleMenuToggle}
                >
                  <EllipsisOutlined />
                </div>
                <div className="dropdown-menu">
                  <ul>
                    <li onClick={(event) => startAltTextModal(image, event)}>
                      <ADAIcon color="#000" /> ADA Text
                    </li>
                    <li onClick={(event) => removeImage(image, event)}>
                      <DeleteOutlined /> Delete
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <FavoriteButton isFavorite={image.isFavorite} assetId={image.id} type="upload" callback={() => {
              image.isFavorite = !image.isFavorite;
              setUploadedImages(uploadedImages.map(img => ({ ...img })));
            }} />
          </div>
        </div>
      </div>

      return (component);
    } else {
      return (
        <div className="component-wrapper" onClick={() => handleCheckboxChange(image)}>
          <div className={`component template frame ${selectedImages.includes(image.id) ? "selected" : ""}`} data-component="frame" id={`upload-${image.id}`}>
            <div className="frame" data-component="frame" data-type="frame" style="display: table-row;" data-asset-id={image.assetId}>
              <div className="img" data-original-bg-img={util.getUploadedImgSrc(image)} style={`width: 100%; height: 100%;`}>
                <img loading={'lazy'} style="width: 100%; height: 100%;" className="img" src={util.getUploadedImgSrc(image)} alt={image.altText} />
              </div>
            </div>
          </div>

          <div className={`checkbox ${selectedImages.includes(image.id) ? "selected" : ""}`}>
            <input type="checkbox" id={`checkbox-${image.id}`} checked={selectedImages.includes(image.id)} />
          </div>

          <div className={`actions ${!image.isOld ? "remove" : "hidden"}`}>
            <div className="dropdown menu-container">
              <div
                className="dropdown-toggle menu-toggle"
                onClick={handleMenuToggle}
              >
                <EllipsisOutlined />
              </div>
              <div className="dropdown-menu">
                <ul>
                  <li onClick={(event) => startCropper(image, event)}>
                    <CropImageIcon /> Crop Photo
                  </li>
                  <li onClick={(event) => startAltTextModal(image, event)}>
                    <ADAIcon color="#000" /> ADA Text
                  </li>
                  <li onClick={(event) => removeImage(image, event)}>
                    <DeleteOutlined /> Delete
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <FavoriteButton isFavorite={image.isFavorite} assetId={image.id} type="upload" callback={() => {
            image.isFavorite = !image.isFavorite;
            // uploadedImages.find(it => it.id === image.id).isFavorite = image.isFavorite;
          }} />
        </div>
      )
    }
  });

  const imageElements = (<Masonry updateOnEachImageLoad={false} className={'masonry-grid'}>
    {elements}
  </Masonry>);

  return open ? createPortal(<div>
    <div className="modal-back" onClick={onClose} />
    <div className="modal organize-uploads-modal" onClick={e => e.stopPropagation()}>
      <a className="close" onClick={onClose}>
        <svg>
          <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-close"} />
        </svg>
      </a>

      <header>
        <h2>Manage Images</h2>
      </header>

      <div className="content">
        {selectedImages.length > 0 && <div className="select-all-wrapper">
          <div className="checkbox">
            <input type="checkbox" id="select-all" checked={selectedImages.length === uploadedImages.length} onChange={() => handleSelectAll()} />
            <label htmlFor="select-all">{selectedImages.length === uploadedImages.length ? "Deselect All" : "Select All"}</label>
          </div>
        </div>}

        <div className={"scroller"}>
          {/* {imageLoadingSpinner}
         */}
          <div className="components images">
            {imageElements}
          </div>
        </div>
      </div>

      {selectedImages.length > 0 && <footer>
        <button className="btn secondary4" onClick={removeSelectedImages}>Delete</button>
        <button className="btn secondary1" onClick={addSelectedImagesToFavorites}>
          <svg className="heart-filled-icon">
            <use xlinkHref={constants.appPrefix + "/svg/icons.svg#heart-filled-icon-gray"} />
          </svg>
          Favorite
        </button>
        <button className="btn primary" onClick={addSelectedImagesToDesign}>Add to design</button>
      </footer>}
    </div>
  </div>, document.getElementById('modals')!) : null;
}
